import React, { Component } from "react";

class LoadingDots extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dots: "",
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState((prevState) => ({
        dots: prevState.dots.length < 3 ? prevState.dots + "." : "",
      }));
    }, 500);
  }

  componentWillUnmount() {
    clearInterval(this.interval); // Clean up the interval
  }

  render() {
    const { children = "Working on it", width = "92px" } = this.props; // Default to "Loading" if no children passed
    const { dots } = this.state;

    return (
      <div style={{width}}>
        {children}
        {dots}
      </div>
    );
  }
}

export default LoadingDots;
